module.exports = __webpack_public_path__ + "img/home-case-03.e8062e7a.png";